import type { ReactNode } from 'react';
import clsx from 'clsx';

import style from './badge.module.scss';

type Props = {
  children: ReactNode;
  className?: string;
};

// Do not use this component directly. Use the badges/ components instead
export const Badge = ({ children, className }: Props) => {
  const badgeClasses = clsx(style.Badge, className);

  return <span className={badgeClasses}>{children}</span>;
};
